import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { useNavigate } from "react-router-dom";
import { machineProfile, location, dataProcess, alertV2 } from "../../api";
import { printLocation } from "../../utils/helper";
import "bootstrap-daterangepicker/daterangepicker.css";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import Select from "react-select";
import LocationTree from "../../components/LocationTreeAsset";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { downloadExcel } from "../../utils/exporter";
import { toast } from "react-toastify";
import {

  formatDateOnly,
  formatDateTime,
} from "../../utils/helper.jsx";
import ReportView from "./ReportView";
import { useReactToPrint } from "react-to-print";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import LoadingIndicator from "../../components/LoadingIndicator";
const initStartDate = Moment().subtract(1, "months");

const initEndDate = Moment();
function ReportPage() {
  const [selectedMachine, setSelectedMachine] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [reportType, setReportType] = React.useState("WorkOrder");
  const componentRef = useRef();
  const {
    totalAPI,
    progressAPI,
    updateTotalAPI,
    addTotalAPI,
    addProgressAPI,
    updateStatusReport,
  } = useDashboardContext();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [spectrumChart, setSpectrumChart] = useState("Envelope FFT");
  const [timeWaveformChart, setTimeWaveformChart] =
    useState("Velocity Waveform");
  const [locationData, setLocationData] = useState([]);
  const [machineAlarm, setMachineAlarm] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({
    Acceptable: 1,
    Observe: 1,
    Alert: 1,
    Critical: 1,
    Pending: 1,
  });
  const [formStatus, setFormStatus] = useState([
    {
      status: "Work Order",
      active: 1,
      description: "All Work Order detail",
      spectrum: "Velocity FFT",
      waveform: "Velocity Waveform",
      temperature: "",
    },
    {
      status: "Request",
      active: 0,
      description: "All Request detail created for selected Asset",
      spectrum: "Velocity FFT",
      waveform: "Velocity Waveform",
      temperature: "",
    },
    {
      status: "Part & Inventories",
      active: 0,
      description: "All Parts that being used for the Work order",
      spectrum: "Velocity FFT",
      waveform: "Velocity Waveform",
      temperature: "",
    },
    {
      status: "Issues",
      active: 0,
      description: "All Issues for selected Locations and Assets",
      spectrum: "Velocity FFT",
      waveform: "Velocity Waveform",
      temperature: "",
    },
  ]);
  const [listMachine, setListMachine] = useState([]);
  const [dateRangeCurrentWeek, setDateRangeCurrentWeek] = useState(
    initStartDate.format("D MMM YYYY") +
    " - " +
    initEndDate.format("D MMM YYYY")
  );
  const [startDate, setStartDate] = useState(null);
  const [listIssues, setListIssues] = useState([]);
  const [endDate, setEndDate] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [form, setForm] = useState({
    report_name: "",
    report_type: "",
    trend_plot: "rms_vel",
    spectrum: [{ value: "Velocity FFT", label: "Velocity FFT" }],
    waveform: [{ value: "Velocity Waveform", label: "Velocity Waveform" }],
    start_date: initStartDate.format("YYYY-MM-DD HH:mm"),
    end_date: initEndDate.format("YYYY-MM-DD HH:mm"),
  });
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  function startLoading(length) {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = Math.random() * 10;
        const tmp = Math.min(oldProgress + diff, 100);
        return parseInt(tmp);
      });
    }, 500 * (length / 6));

    return () => {
      clearInterval(timer);
    };
  }
  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");
    setStartDate(startDate);
    setEndDate(endDate);
    setForm({
      ...form,
      start_date: startDate.startOf("day").format("YYYY-MM-DD HH:mm"),
      end_date: endDate.endOf("day").format("YYYY-MM-DD HH:mm"),
    });
    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");
    var prevWeek =
      Moment(startDate).subtract(gap, "days").format("D MMM") +
      " - " +
      Moment(startDate).subtract(1, "days").format("D MMM YYYY");

    setDateRangeCurrentWeek(currentWeek);
  }
  async function getLocation() {
    const res = await location.list("", "", "", "", "", 2);
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      let tmp = [];
      data.forEach((item) => {
        if (item.sublocations?.length > 0) {
          item.sublocations?.forEach((sub) => {
            if (sub.sublocations?.length > 0) {
              sub.sublocations?.forEach((sub2) => {
                tmp.push({
                  value: sub2.id,
                  label:
                    printLocation(item.location_name) +
                    " | " +
                    printLocation(sub.location_name) +
                    " | " +
                    printLocation(sub2.location_name),
                });
              });
            } else {
              tmp.push({
                value: sub.id,
                label:
                  printLocation(item.location_name) +
                  " | " +
                  printLocation(sub.location_name),
              });
            }
          });
        }
      });
      setLocationData(tmp);
    }
    setLoading(false)
  }
  const handleChangeLocationFilter = (location_id) => {
    setForm((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  useEffect(() => {
    setLoading(true);
    getLocation();
  }, []);
  const navigate = useNavigate();
  function handleMachineHealth(id) {
    navigate("/sensor/live/" + id);
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    const [key, status] = name.split("-");
    setFormStatus((prev) =>
      prev.map((item) => {
        if (item.status === status) {
          return { ...item, [key]: value };
        }
        return item;
      })
    );
  };

  const handleChangeTrend = (e) => {
    setForm({ ...form, trend_plot: e });
  };
  const handleChangeSpectrum = (e) => {
    setForm({ ...form, spectrum: e });
  };
  const handleChangeWaveform = (e) => {
    setForm({ ...form, waveform: e });
  };

  const handleChangeLocation = (event) => {
    //console.log({ event });
    setSelectedLocation(
      // On autofill we get a stringified value.
      event
    );
  };
  async function fetchData() {
    // const res = await dataProcess.machineHealthAllQuery("Location", {
    //   machineType: selectedMachineClass,
    // });
    // const datas = await parserAPI(res);
    // let result = [];
    // datas.forEach((data) => {
    //   if (data.MachineHealth.length) {
    //     data.MachineHealth.forEach((machine) => {
    //       result.push({
    //         machine_name: data.machine_name,
    //         machine_health_status: machine.status,
    //         status_date: formatDateOnly(machine.created_at),
    //         machine_brand: data.machine_brand,
    //         iso_standard: data.iso_standard ? data.iso_standard : "-",
    //         description: machine.description,
    //       });
    //     });
    //   } else {
    //     result.push({
    //       machine_name: data.machine_name,
    //       health_status: "Pending",
    //       _status_date: "-",
    //       machine_brand: data.machine_brand,
    //       iso_standard: data.iso_standard ? data.iso_standard : "-",
    //       description: "-",
    //     });
    //   }
    // });
    // // let data = [
    // //   {
    // //     sheet: "Report",
    // //     columns: [
    // //       { label: "Machine Name", value: "machine_name" }, // Top level data
    // //       { label: "Machine Health Status", value: "machine_health_status" }, // Top level data
    // //       {
    // //         label: "Machine Health Status Date",
    // //         value: "machine_health_status_date",
    // //       }, // Top level data
    // //       { label: "Machine Type", value: "machine_type" }, // Top level data
    // //       { label: "Machine Brand", value: "machine_brand" }, // Top level data
    // //       { label: "Iso Standard", value: "iso_standard" }, // Top level data
    // //     ],
    // //     content: result,
    // //   },
    // // ];
    // // let settings = {
    // //   fileName: reportName, // Name of the resulting spreadsheet
    // //   extraLength: 3, // A bigger number means that columns will be wider
    // //   writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    // //   writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    // //   RTL: false, // Display the columns from right-to-left (the default value is false)
    // // };
    //
    // // make result into [[],[],[]] format
    // let resultArray = [];
    // result.forEach((item) => {
    //   resultArray.push(Object.values(item));
    // });
    //
    // // xlsx(data, settings);
    // autoTable(doc, {
    //   head: [
    //     [
    //       "machine_name",
    //       "health_status",
    //       "status_date",
    //       "machine_brand",
    //       "iso_standard",
    //       "description",
    //     ],
    //   ],
    //   body: resultArray,
    // });
    //
    // // Sometimes you might have to call the default function on the export (for example in Deno)
    // // autoTable.default(doc, { html: "#my-table" });
    //
    // doc.save(`${reportName}.pdf`);
  }

  async function generateReport() {

    if (!selectedMachine.length || !form.start_date || !form.end_date) {
      toast.error("Please Select Location and Date Range");
      return;
    }

      if(reportType==='WorkOrder'){
          setLoading(true);
          const submitForm = { ...form, location_ids: selectedMachine };
          const getWorkOrder =await dataProcess.generateReportCMMSWorkOrder(submitForm);
          setLoading(false);
          if(getWorkOrder.ok){
              const data = await getWorkOrder.json();
            const workOrder = data.data.map((item) => {
              const status_updated_by =
                item.WorkOrderLogs.length > 0
                  ? item.WorkOrderLogs[0]?.user?.firstname
                  : "";
              const status_updated_date =
                item.WorkOrderLogs.length > 0
                  ? formatDateTime(item.WorkOrderLogs[0]?.created_at)
                  : formatDateTime(item.updated_at);

              return {
                no: item.number,
                title: item.title,
                description: item.description,
                start_date: formatDateOnly(item.start_date),
                due_date: formatDateOnly(item.due_date),
                ...item.locationLevels,
                ...item.chainProblem,
                asset: item.asset?.asset_name,
                issue_type_note: item.problem_type_note,
                priority: item.priority,
                category: item.category?.name,
                fault: item.fault,
                assign_to: item.assigned_to_user
                  ? item.assigned_to_user?.user?.firstname
                  : item.team?.team_name,
                status: item.status,
                status_updated_by: status_updated_by,
                status_updated_date: status_updated_date,
                created_by: item.created_by_user?.user?.firstname,
                created_date: formatDateTime(item.created_at),
              };
            });
              downloadExcel(workOrder, reportType)
          }

      return;
    }
    if (reportType === 'Asset') {
      setLoading(true);
      const submitForm = { ...form, location_ids: selectedMachine };
      const getWorkOrder = await dataProcess.generateReportCMMSAsset(submitForm);
      setLoading(false);
      if (getWorkOrder.ok) {
        const data = await getWorkOrder.json();
        const workOrder = data.data.map((item) => {
          return {
            id: item.id,
            asset_name: item.asset_name,
            asset_model: item.asset_model,
            serial_number: item.serial_number,
            description: item.description,
            ...item.locationLevels,
            category: item.category?.name,
            created_date: formatDateTime(item.created_at),
          }
        })
        downloadExcel(workOrder, reportType)
      }

      return;
    }
    if (reportType === 'Request') {
      setLoading(true);
      const submitForm = { ...form, location_ids: selectedMachine };
      const getWorkOrder = await dataProcess.generateReportCMMSRequest(submitForm);
      setLoading(false);
      if (getWorkOrder.ok) {
        const data = await getWorkOrder.json();
        const workOrder = data.data.map((item) => {
          return {
            no: item.number,
            title: item.title,
            description: item.description,
            start_date: formatDateOnly(item.start_date),
            due_date: formatDateOnly(item.due_date),
            ...item.locationLevels,
            priority: item.priority,
            category: item.category?.name,
            status: item.request_status,
            requested_by: item.requested_by ? item.requested_by : item.created_by_user?.user?.firstname,
            created_date: formatDateTime(item.created_at),
          }
        })
        downloadExcel(workOrder, reportType)
      }

      return;
    }
    if (reportType === 'Issues') {
      setLoading(true);
      const submitForm = { ...form, location_ids: selectedMachine };
      const getIssues = await dataProcess.generateReportCMMSIssues(submitForm);
      setLoading(false);
      if (getIssues.ok) {
        const data = await getIssues.json();
        const part = data.data.map((item) => {
          return {
            title: item.title,
            type: item.type?.name,
            description: item.description,
            ...item.locationLevels,
            asset: item.asset?.asset_name,
            status: item.status,
          }
        })
        downloadExcel(part, reportType)
      }
    }
    if (reportType === 'Parts') {
      setLoading(true);
      const submitForm = { ...form, location_ids: selectedMachine };
      const getPart = await dataProcess.generateReportCMMSInventories(submitForm);
      setLoading(false);
      if (getPart.ok) {
        const data = await getPart.json();
        const part = data.data.map((item) => {
          return {
            part: item.part.part_name,
            part_number: item.part.part_number,
            part_cost: item.part.part_cost,
            location: item.location.location_name,
            quantity: item.quantity,
            ...item.locationLevels,
          }
        })
        downloadExcel(part, reportType)
      }

      return;
    }
  }
  async function generateReportOld() {
    // check at least one of statusform are active
    const statusActive = formStatus.filter((item) => item.active === 1);
    if (!statusActive.length) {
      toast.error("Please select at least one status");
      return;
    }

    updateStatusReport(formStatus);
    setProgress(0);

    const machine_length = selectedMachine.length;
    updateTotalAPI(machine_length * 4);
    startLoading(machine_length * 4);
    setLoading(true);
    // const locationIDs = selectedLocation.map((loc) => loc.value);
    const submitForm = { ...form, asset_ids: selectedMachine };

    const arrayRequest = [];

    const getReport = dataProcess.generateReportCMMS(submitForm);
    arrayRequest.push(getReport);

    if (formStatus.find((item) => item.status === "Issues").active === 1) {
      const getIssues = dataProcess.generateReportCMMSIssues(submitForm);
      arrayRequest.push(getIssues);
    }

    const results = await Promise.all(arrayRequest);

    if (results[0].ok) {
      const body = await results[0].json();

      //Only for Work Order, Request, Part & Inventories
      if (
        formStatus.some((item) => item.status !== "Issues" && item.active === 1)
      ) {
        setListMachine(body.data);
      } else {
        setListMachine([]);
      }
      addProgressAPI(machine_length);
    }

    //for Issues Report
    if (results[1] && results[1].ok) {
      const body = await results[1].json();
      setListIssues(body.data);
    } else {
      setListIssues([]);
    }
  }

  useEffect(() => {
    //console.log({ totalAPI, progressAPI });
  }, [progressAPI]);

  function ChangeSpectrumChart(event) {
    setSpectrumChart(event.target.value);
  }
  function ChangeTimeWaveformChart(event) {
    setTimeWaveformChart(event.target.value);
  }

  function onChangeTree(value) {
    setSelectedMachine(value);
  }
  useEffect(() => { }, [selectedStatus]);
  function changeStatus(event) {
    const { name, checked } = event.target;
    setFormStatus((prev) =>
      prev.map((item) => {
        if (item.status === name) {
          return { ...item, active: checked ? 1 : 0 };
        }
        return item;
      })
    );
  }

  const options_trend = [
    { value: "rms_vel", label: "Velocity RMS" },
    { value: "rms_acc", label: "Acceleration RMS" },
    { value: "peak_acc", label: "Peak Acceleration" },
    { value: "pk_pk_acc", label: "Peak to Peak Acceleration" },
  ];

  const options_epectrum = [
    { value: "Envelope FFT", label: "Envelope FFT" },
    { value: "Velocity FFT", label: "Velocity FFT" },
    { value: "Acceleration FFT", label: "Acceleration FFT" },
  ];

  const options_timewaveform = [
    { value: "Velocity Waveform", label: "Velocity Waveform" },
    { value: "Acceleration Waveform", label: "Acceleration Waveform" },
  ];

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#/">REPORT</a>
                </li>
                <li className="breadcrumb-item active">REPORT GENERATOR</li>
              </ul>

              <h1 className="page-header">Report Generator</h1>

              <hr className="mb-4" />

              <div id="datatable" className="mb-5">
                <div className="row justify-content-center mb-5">
                  <div className="col-md-6 mb-2">
                    <LocationTree onChangeTree={onChangeTree} />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Card>
                      <CardHeader>Filter Report</CardHeader>
                      <CardBody>
                        <NormalSelect
                          label={"Report Type"}
                          onchange={(e) => setReportType(e.target.value)}
                          value={reportType}
                          name={"report_type"}
                          className="form-select"
                          required
                          list={[
                            {
                              id: "Asset",
                              name: "Asset",
                            },
                            {
                              id: "WorkOrder",
                              name: "Work Order",
                            },
                            {
                              id: "Request",
                              name: "Request",
                            },
                            {
                              id: "Parts",
                              name: "Part & Inventories",
                            },
                            {
                              id: "Issues",
                              name: "Issues",
                            },
                          ]}
                          valueKey={"id"}
                        />
                        <div className="form-group mt-3">
                          <label className={"form-label"}>Select Date</label>
                          <DateRangePicker
                            startDate={startDate}
                            endDate={endDate}
                            onApply={handleDateApplyEvent}
                          >
                            <button
                              className="btn btn-outline-light text-truncate me-3 mb-2 mb-sm-0 text-left "
                              style={{ width: "100%", textAlign: "left" }}
                            >
                              <i className="fa fa-fw fa-calendar me-1"></i>
                              <span>{dateRangeCurrentWeek}</span>
                              <i className="fa fa-fw fa-caret-down me-n1"></i>
                            </button>
                          </DateRangePicker>
                        </div>

                        <div className={"mt-2"}>
                          {/*<div>Show Data on Report</div>*/}
                          {/*{formStatus.map((status, index) => (*/}
                          {/*  <Card key={index} className={"mb-1"}>*/}
                          {/*    <CardHeader>*/}
                          {/*      <div className="form-check">*/}
                          {/*        <input*/}
                          {/*          className="form-check-input"*/}
                          {/*          type="checkbox"*/}
                          {/*          checked={status.active === 1}*/}
                          {/*          name={status.status}*/}
                          {/*          value={1}*/}
                          {/*          onChange={changeStatus}*/}
                          {/*          id="Acceptable"*/}
                          {/*        ></input>*/}
                          {/*        <label*/}
                          {/*          className="form-check-label"*/}
                          {/*          htmlFor="Acceptable"*/}
                          {/*        >*/}
                          {/*          {status.status}*/}
                          {/*        </label>*/}
                          {/*      </div>*/}
                          {/*    </CardHeader>*/}
                          {/*    {status.active === 1 ? (*/}
                          {/*      <CardBody>{status.description}</CardBody>*/}
                          {/*    ) : null}*/}
                          {/*  </Card>*/}
                          {/*))}*/}

                          {/*<Select*/}
                          {/*  options={options_epectrum}*/}
                          {/*  isMulti={true}*/}
                          {/*  value={form.spectrum}*/}
                          {/*  onChange={handleChangeSpectrum}*/}
                          {/*  classNamePrefix="react-select"*/}
                          {/*/>*/}
                          {/*<Select*/}
                          {/*  options={options_timewaveform}*/}
                          {/*  isMulti={true}*/}
                          {/*  value={form.waveform}*/}
                          {/*  onChange={handleChangeWaveform}*/}
                          {/*  classNamePrefix="react-select"*/}
                          {/*/>*/}

                          {/*<div className="form-check">*/}
                          {/*  <input*/}
                          {/*    name={"Observe"}*/}
                          {/*    className="form-check-input"*/}
                          {/*    type="checkbox"*/}
                          {/*    onChange={changeStatus}*/}
                          {/*    checked={selectedStatus.Observe === 1}*/}
                          {/*    value={1}*/}
                          {/*    id="Observe"*/}
                          {/*  ></input>*/}
                          {/*  <label*/}
                          {/*    className="form-check-label"*/}
                          {/*    htmlFor="Observe"*/}
                          {/*  >*/}
                          {/*    Observe*/}
                          {/*  </label>*/}
                          {/*</div>*/}
                          {/*<div className="form-check">*/}
                          {/*  <input*/}
                          {/*    name={"Alert"}*/}
                          {/*    className="form-check-input"*/}
                          {/*    type="checkbox"*/}
                          {/*    onChange={changeStatus}*/}
                          {/*    checked={selectedStatus.Alert === 1}*/}
                          {/*    value={1}*/}
                          {/*    id="Alert"*/}
                          {/*  ></input>*/}
                          {/*  <label className="form-check-label" htmlFor="Alert">*/}
                          {/*    Alert*/}
                          {/*  </label>*/}
                          {/*</div>*/}
                          {/*<div className="form-check">*/}
                          {/*  <input*/}
                          {/*    name={"Critical"}*/}
                          {/*    className="form-check-input"*/}
                          {/*    type="checkbox"*/}
                          {/*    onChange={changeStatus}*/}
                          {/*    checked={selectedStatus.Critical === 1}*/}
                          {/*    value={1}*/}
                          {/*    id="Critical"*/}
                          {/*  ></input>*/}
                          {/*  <label*/}
                          {/*    className="form-check-label"*/}
                          {/*    htmlFor="Critical"*/}
                          {/*  >*/}
                          {/*    Critical*/}
                          {/*  </label>*/}
                          {/*</div>*/}
                          {/*<div className="form-check">*/}
                          {/*  <input*/}
                          {/*    name={"Pending"}*/}
                          {/*    className="form-check-input"*/}
                          {/*    type="checkbox"*/}
                          {/*    onChange={changeStatus}*/}
                          {/*    checked={selectedStatus.Pending === 1}*/}
                          {/*    value={1}*/}
                          {/*    id="Pending"*/}
                          {/*  ></input>*/}
                          {/*  <label*/}
                          {/*    className="form-check-label"*/}
                          {/*    htmlFor="Pending"*/}
                          {/*  >*/}
                          {/*    Pending*/}
                          {/*  </label>*/}
                          {/*</div>*/}
                        </div>

                        <div className={"text-center mt-5"}>
                          {
                            loading ? (
                              <div> Loading... </div>
                            ) : (
                              <button
                                className="btn btn-theme"
                                onClick={generateReport}
                              >
                                Generate Report in Excel
                              </button>
                            )
                          }

                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                {/*<Card>*/}
                {/*  <CardHeader>*/}
                {/*    <div className={"d-flex justify-content-between"}>*/}
                {/*      <div>Report Preview</div>*/}
                {/*      <button*/}
                {/*        className="btn btn-sm btn-outline-theme"*/}
                {/*        onClick={handlePrint}*/}
                {/*      >*/}
                {/*        <i className="fa fa-print"></i> Print / Export PDF*/}
                {/*      </button>*/}
                {/*    </div>*/}
                {/*    {progress > 0 && progress < 100 && (*/}
                {/*      <ProgressBar*/}
                {/*        variant={"success"}*/}
                {/*        animated*/}
                {/*        now={progress}*/}
                {/*        label={`${progress}%`}*/}
                {/*      />*/}
                {/*    )}*/}
                {/*  </CardHeader>*/}
                {/*  <CardBody*/}
                {/*    style={{*/}
                {/*      background: progress > 0 ? "white" : "transparent",*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    <div style={{ margin: "auto" }} ref={componentRef}>*/}
                {/*      <div className="p-4">*/}
                {/*        {progress === 0 ? (*/}
                {/*          <div className="text-center">- No Data -</div>*/}
                {/*        ) : null}*/}

                {/*        {listMachine.length === 0 &&*/}
                {/*        listIssues.length === 0 &&*/}
                {/*        progress === 100 ? (*/}
                {/*          <div className="text-center text-black">*/}
                {/*            - No Data Available -*/}
                {/*          </div>*/}
                {/*        ) : null}*/}

                {/*        <div className="page-break" />*/}
                {/*        {progress > 90 &&*/}
                {/*          (listMachine.length > 0 || listIssues.length > 0) && (*/}
                {/*            <ReportView*/}
                {/*              list={listMachine}*/}
                {/*              form={form}*/}
                {/*              formStatus={formStatus}*/}
                {/*              listIssues={listIssues}*/}
                {/*            />*/}
                {/*          )}*/}
                {/*      </div>*/}
                {/*      /!*<MachineAlert data={machineAlarm} />*!/*/}
                {/*    </div>*/}
                {/*  </CardBody>*/}
                {/*</Card>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportPage;
